<div *ngIf="!isHidden()" class="list-group list-group-flush" [ngClass]="{'scrollable': forceMaxHeight }">
    <div *ngIf="displayActions && actions" class="d-flex pb-2 pe-2">
        <div class="btn-group ms-auto"
            [sq-action-buttons]="{items: actions, size: 'sm'}">
        </div>
    </div>

    <div *ngIf="searchItems.selected" class="position-relative" [formGroup]="myGroup">
        <div class="p-1">
            <input class="form-control" sqAutofocus
                formControlName="searchQuery"
                [placeholder]="'msg#facet.searchPlaceholder' | sqMessage">
        </div>
        <sq-loading-bar [active]="searchActive"></sq-loading-bar>
    </div>

    <!-- hidden selected items -->
    <div *ngFor="let item of hiddenSelected"
        class="d-flex flex-row list-group-item sq-selected"
        [title]="'msg#facet.itemUnselect' | sqMessage"
        (click)="selectItem(item, $event)">

        <input type="checkbox" class="form-check-input me-2" [checked]="true" *ngIf="showCheckbox">

        <a href="#" (click)="filterItem(item, $event)"
            [title]="'msg#facet.filterItem' | sqMessage:{'terme':(item.$path | slice:1:-1)}"
            class="text-truncate me-auto">{{item.$path | slice:1:-1}}</a>

        <span *ngIf="showCount && item.count" class="ms-2 text-muted small">{{item.count | sqNumber}}</span>
    </div>

    <span *ngIf="noResults" class="d-block text-center text-muted small py-1"><i>{{'msg#facet.searchNoResult' | sqMessage}}</i></span>

    <ng-container *ngTemplateOutlet="itemsTpl; context:data"></ng-container>

</div>

<ng-template #itemsTpl let-items="items">
    <ng-container *ngFor="let item of items">

        <div class="d-flex flex-row align-items-center list-group-item list-group-item-action"
            [ngClass]="{'sq-filtered':item.$filtered, 'sq-selected': isSelected(item)}"
            [title]="(item.$filtered ? 'msg#facet.selectedValue' : 'msg#facet.itemSelect') | sqMessage"
            (click)="selectItem(item, $event)">

            <span class="me-auto text-truncate" [ngStyle]="{'margin-left.rem' : indentFactor * (item['$level'] - 1)}">

                <a *ngIf="item['hasChildren']" class="item-opener" href="#" (click)="open(item, $event)" [title]="(item['$opened'] ? 'msg#facet.closeItem' : 'msg#facet.openItem') | sqMessage">
                    <span *ngIf="item['$opening']" class="fas fa-sync fa-fw fa-spin"></span>
                    <span *ngIf="!item['$opening'] && item['$opened']" class="fas fa-caret-down fa-fw"></span>
                    <span *ngIf="!item['$opening'] && !item['$opened']" class="fas fa-caret-right fa-fw"></span>
                </a>
                <span *ngIf="!item['hasChildren']" class="fas fa-fw"></span>

                <input type="checkbox" class="form-check-input me-1" [checked]="isSelected(item)" (change)="selectItem(item,$event)" (click)="$event.stopPropagation()" *ngIf="showCheckbox && !item.$filtered">

                <a  href="#" (click)="filterItem(item, $event)"
                    role="button" [title]="item | sqValue:item.$column"
                    class="text-truncate">
                    <input type="checkbox" class="form-check-input me-1" [checked]="true" disabled *ngIf="showCheckbox && item.$filtered">
                    {{item | sqValue:item.$column}}
                </a>

            </span>

            <span *ngIf="showCount && item.count" class="ms-2 text-muted small">{{item.count | sqNumber}}</span>

        </div>

        <ng-container *ngIf="item['$opened']">

            <ng-container *ngTemplateOutlet="itemsTpl; context:item"></ng-container>

        </ng-container>

    </ng-container>

</ng-template>
